<div class="overlay-loader" [class.overlay-loader--visible]="isLoading">
  <div class="spinner"></div>
</div>

<ng-container *ngIf="isAuthenticated(); else unauthenticated">
  <app-side-nav-inner-toolbar>
    <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
  </app-side-nav-inner-toolbar>
</ng-container>

<ng-template #unauthenticated>
  <app-unauthenticated-content></app-unauthenticated-content>
</ng-template>


<div style="background-color: var(--main-color);">
  <app-footer></app-footer>
</div>
